<template>
  <div class="swapsies" :data-swapped="swapped" :data-swapping="swapping">
    <div ref="startContainer" class="start">
      <slot name="start"></slot>
    </div>

    <div class="end" :data-effect="inEffect" v-if="swapped">
      <slot name="end"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "Swapsies",
  props: ["delay", "startMethod", "inEffect"],
  data: () => {
    return {
      swapped: false,
      swapping: false,
      swappingTimeout: null,
    }
  },
  methods: {
    swap () {
      if (this.swapped) {
        // No takesbacksies
        return;
      }
      this.swapping = true
      if (this.startMethod) {
        // Uh, I guess we can assume that if a startMethod is passed, then the first
        // slot will be filled with a Vue element and therefore this is safe to run.
        // Honest.
        this.$children[0][this.startMethod]()
      }

      clearTimeout(this.swappingTimeout)

      if (this.delay) {
        this.swappingTimeout = setTimeout(this.completeSwap, this.delay)
      } else {
        this.completeSwap()
      }
    },
    completeSwap () {
      this.swapped = true
    }
  }
}
</script>

<style lang="scss" scoped>
  .swapsies {
    position: relative;
    .start {
      visibility: visible;
    }
    .end {
      visibility: hidden;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      display: flex;
      flex-flow: row nowrap;
      justify-content: center;
      align-items: center;
    }

    &[data-swapped="true"] {
      .start {
        visibility: hidden;
      }
      .end {
        visibility: visible;
      }
    }
    .end {
      &[data-effect="fadeIn"] {
        opacity: 0;
        animation: fade-in 0.5s forwards;
      }
    }
  }

  @keyframes fade-in {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
</style>
